import actionTypes from "./actionTypes";
import * as vyjadrenieUtils from "../utils/vyjadrenieUtils";
import * as filesUtils from "../utils/filesUtils";

export const ulozData = (data) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.VYJADRENIE_SAVE_DATA,
      data,
    });
  };
};

export const changeVyjadrenie = (vyjadrenie) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_VYJADRENIE,
      data: vyjadrenie,
    });
  };
};

const ulozitVyjadrenieRequest = () => ({
  type: actionTypes.CREATE_VYJADRENIE_REQUEST,
});
const ulozitVyjadrenieSuccess = (res) => ({
  type: actionTypes.CREATE_VYJADRENIE_SUCCESS,
  res,
});
const ulozitVyjadrenieFailure = (error) => ({
  type: actionTypes.CREATE_VYJADRENIE_FAILURE,
  error,
});
export const ulozitVyjadrenie = (
  vyjadrenie,
  fileNames,
  files = [],
  reportsName = []
) => {
  return async (dispatch) => {
    try {
      dispatch(ulozitVyjadrenieRequest());
      const res = await vyjadrenieUtils.ulozitVyjadrenie(vyjadrenie);
      const I_AG_VYJADRENIE = res.Data;
      const I_AG_ZIADOST = vyjadrenie.I_AG_ZIADOST;

      for (let i = 0; i < files.length; i++) {
        await filesUtils.uploadPrilohaVyjadrenie(
          I_AG_VYJADRENIE,
          fileNames[i],
          files[i]
        );
      }
      for (let i = 0; i < reportsName.length; i++) {
        await filesUtils.uploadReport(
          reportsName[i],
          I_AG_ZIADOST,
          I_AG_VYJADRENIE
        );
      }
      dispatch(ulozitVyjadrenieSuccess(res));
    } catch (error) {
      dispatch(ulozitVyjadrenieFailure(error));
    }
  };
};

const getListVyjadrenieRequest = () => ({
  type: actionTypes.GET_LIST_VYJADRENIE_REQUEST,
});
const getListVyjadrenieSuccess = (res) => ({
  type: actionTypes.GET_LIST_VYJADRENIE_SUCCESS,
  res,
});
const getListVyjadrenieFailure = (error) => ({
  type: actionTypes.GET_LIST_VYJADRENIE_FAILURE,
  error,
});
export const getListVyjadrenie = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      dispatch(getListVyjadrenieRequest());
      let res = await vyjadrenieUtils.getListVyjadrenie(filter, sort, page);
      dispatch(getListVyjadrenieSuccess(res));
    } catch (error) {
      dispatch(getListVyjadrenieFailure(error));
    }
  };
};
